import React, { useState } from 'react';
import { Grid } from '@mui/material';

import TableX from '../../../../../components/Tables/TableX';
import { Icon, Paginate, PopUp, showToast } from '../../../../../components/ui';
import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';
import LoadingSpinner from '../../../../../components/Components/LoadingSpinner';
import CustomizeButtonComponent from '../../../../../components/Buttons/CustomizeButtonComponent';

const SelectDataPeriod = (props) => {
    const [rowsCount, setRowsCount] = useState(50);
    const [numPage, setNumPage] = useState(1);
    const [filter, setFilter] = useState([]);
    const [filterBy, setFilterBy] = useState([]);
    const [stateX, setStateX] = useState({});
    const [sortArr, setSortArr] = useState([]);
    const [goTo, setGoTo] = useState(1);

    const emptyState = () => {
        setNumPage(1);
        setRowsCount(50);
        props.setTotalRows(50);
        setFilter([]);
        setFilterBy([]);
        setGoTo(1);
        setSortArr([]);
        setStateX({});
    };

    function Select() {
        if (props.SelectedData.id === undefined) {
            showToast({ type: 'error', message: 'Please Select Data!' });
        }
        else {
            let beginDate = new Date(props.SelectedData.beginningPeriod);
            var dateBegin = beginDate.toLocaleDateString("sv-se").split('T')[0];
            let closeDate = new Date(props.SelectedData.endDatePeriod);
            var dateClose = closeDate.toLocaleDateString("sv-se").split('T')[0];

            if (props.periodSelected === 'Beginning') {
                if (props.isRangePeriod === false) {
                    props.setBPeriod(props.SelectedData.period);
                    props.setBYearPeriod(props.SelectedData.yearPeriod);
                    props.setBStartPeriod(dateBegin);
                    props.setBEndPeriod(dateClose);

                    emptyState();
                    props.handleClick();

                    props.setIsModal(false);
                }
                else if (props.isRangePeriod === true) {
                    let check = 0;
                    if (props.lYearPeriod !== '') {
                        if (parseInt(props.lYearPeriod) >= props.SelectedData.yearPeriod) {
                            if (props.lPeriod !== '') {
                                if (parseInt(props.lPeriod) >= props.SelectedData.period) {
                                    check = 1;
                                }
                            }
                            else {
                                check = 1;
                            }
                        }
                    }
                    else {
                        check = 1;
                    }

                    if (check === 1) {
                        props.setBPeriod(props.SelectedData.period);
                        props.setBYearPeriod(props.SelectedData.yearPeriod);
                        props.setBStartPeriod(dateBegin);
                        props.setBEndPeriod(dateClose);

                        emptyState();
                        props.handleClick();

                        props.setIsModal(false);
                    }
                    else {
                        showToast({ type: 'error', message: 'Please Select Valid Closing Period!' });
                    }
                }
            }
            else if (props.periodSelected === 'Ending') {
                let check = 0;
                if (props.bYearPeriod !== '') {
                    if (parseInt(props.bYearPeriod) <= props.SelectedData.yearPeriod) {
                        if (props.bPeriod !== '') {
                            if (parseInt(props.bPeriod) <= props.SelectedData.period) {
                                check = 1;
                            }
                        }
                        else {
                            check = 1;
                        }
                    }
                }
                else {
                    check = 1;
                }

                if (check === 1) {
                    props.setLPeriod(props.SelectedData.period);
                    props.setLYearPeriod(props.SelectedData.yearPeriod);
                    props.setLStartPeriod(dateBegin);
                    props.setLEndPeriod(dateClose);

                    emptyState();
                    props.handleClick();

                    props.setIsModal(false);
                }
                else {
                    showToast({ type: 'error', message: 'Please Select Valid Closing Period!' });
                }
            }
        }
    };

    function Cancel() {
        emptyState();
        props.handleClick();
    };

    const handleReset = () => {
        emptyState();
        props.getData(1, 50);
    };

    function CellDoubleClick() {
        Select();
    }

    const onChangePaging = (value) => {
        setNumPage(value);
        props.getData(value, rowsCount, filter);
    }

    const onChangeLimit = (value) => {
        setNumPage(1);
        setRowsCount(value);
        props.getData(1, value, filter);
    }

    const mainContainer = (
        <>
            <Grid item xs={12} style={{ width: "100%", borderRadius: "5px" }}>
                <div>
                    {
                        ButtonComponent.RefreshButton(
                            sortArr,
                            rowsCount,
                            props.columnData,
                            setGoTo,
                            handleReset,
                            setFilterBy,
                            filterBy,
                            setFilter,
                            setNumPage,
                            setRowsCount,
                            props.getData,
                            stateX,
                            setStateX
                        )
                    }
                </div>

                <div
                    className="rounded-10 table-responsive"
                    style={{
                        maxHeight: '375px',
                        marginTop: '16px',
                        padding: '2px 16px',
                        borderRadius: '12px',
                        background: '#F2F2F2'
                    }}
                >
                    {
                        props.isLoading ?
                            (
                                <LoadingSpinner />
                            )
                            :
                            (
                                <>
                                    <div className="mt-1">
                                        <TableX
                                            uniqueKey={'id'}
                                            goTo={goTo}
                                            rowsCount={rowsCount}
                                            setNumPage={setNumPage}
                                            setRowsCount={setRowsCount}
                                            getData={props.getData}
                                            columnData={props.columnData}
                                            dataMap={props.dataMap}
                                            SelectedData={props.selectedData}
                                            setSelectedData={props.setSelectedData}
                                            setFilter={setFilter}
                                            setFilterBy={setFilterBy}
                                            CellDoubleClick={CellDoubleClick}
                                            stateX={stateX}
                                            setStateX={setStateX}
                                            sortArr={sortArr}
                                            setSortArr={setSortArr}
                                            setGoTo={setGoTo}
                                        />
                                    </div>
                                </>
                            )
                    }
                </div>

                <div style={{ marginTop: '16px' }}>
                    <Paginate
                        page={numPage}
                        limit={rowsCount}
                        totalData={props.totalRows}
                        onChange={onChangePaging}
                        onChangeLimit={onChangeLimit}
                    />
                </div>
            </Grid>
        </>
    );

    return (
        <PopUp
            id='modal-id'
            icon={
                <Icon
                    iconName={'approve-doc'}
                    svgIconProps={{
                        htmlColor: '#0087C2',
                        sx: {
                            height: '24px',
                            width: '24px'
                        }
                    }}
                />
            }
            title={'Select ' + props.titleModal}
            isOpen={props.isModal}
            onClose={Cancel}
            draggable={false}
            shrinkable={false}
            disableScrollLock={false}
            maxWidth={'lg'}
            fullWidth={true}
        >
            <div style={{ padding: '0px 6px' }}>
                {mainContainer}

                <div style={{ padding: '24px 0px 0px' }}>
                    {CustomizeButtonComponent.SelectModalButton(Select)}
                </div>
            </div>
        </PopUp>
    )
}

export default SelectDataPeriod;